import React from 'react';
import EditableTable from '../../components/EditableTable';
import { TextField } from '@mui/material';
import DateTimeField from '../../components/DateTimeField';
import { toLocalDateTimeString } from '../../utils/dateUtils'; // Import utility function

export default function MedicinesTable({ medicines, onMedicinesChange }) {
    const headers = ['Tiempo', 'Peso', 'Farmacos y Dosis', 'V.A.'];

    const cellTemplates = {
        time: {
            read: (value) => toLocalDateTimeString(value), // Use utility function
            edit: (value, onChange) => (
                <DateTimeField
                    name="time"
                    value={value || ''}
                    onChange={(e) => onChange(e.target.value)}
                />
            ),
        },
        weight: {
            read: (value) => value || '',
            edit: (value, onChange) => (
                <TextField
                    variant="standard"
                    type="number"
                    value={value || ''}
                    onChange={(e) => onChange(e.target.value)}
                />
            ),
        },
        dose: {
            read: (value) => value || '',
            edit: (value, onChange) => (
                <TextField
                    variant="standard"
                    value={value || ''}
                    onChange={(e) => onChange(e.target.value)}
                />
            ),
        },
        va: {
            read: (value) => value || '',
            edit: (value, onChange) => (
                <TextField
                    variant="standard"
                    value={value || ''}
                    onChange={(e) => onChange(e.target.value)}
                />
            ),
        },
    };

    const getNewRow = () => {
        const utcTime = new Date().toISOString();
        return {
            id: 0,
            time: utcTime,
            weight: 0,
            dose: '',
            va: '',
        };
    };

    return (
        <EditableTable
            headers={headers}
            data={medicines}
            onDataChange={onMedicinesChange}
            cellTemplates={cellTemplates}
            getNewRow={getNewRow}
            title="Medicinas"
        />
    );
}
